import React, { Component, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from '../../shared/functions';

import Auxiliary from '../../hoc/Auxiliary';
import Head from '../../components/Partials/Head/Head';
import ArticleGroup from '../../components/Blog/ArticleGroup/ArticleGroup';
import Spinner from '../../components/UI/Spinner/Spinner';
import { connect } from 'react-redux';
import { fetchArticle } from "../../store/actions/article"
import axios from 'axios';
import { useNavigate } from 'react-router';

const Post = props => {
    const [id, setId] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [title, setTitle] = useState("")
    const [content, setContent] = useState("")
    const [description, setDescription] = useState("")
    const [date, setDate] = useState("")
    const [sharedImg, setSharedImg] = useState("")

    const navigate = useNavigate()

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        let currentID = queryParams.get("id");
        if (currentID) {
            props.onTryFetchArticle(currentID);
            setId(currentID)
            queryParams.delete(queryParams.get("id"))
            navigate(queryParams, { replace: true });
        }
    }, [window.location])

    useEffect(() => {
        if (id === null && props.posts !== null) {
            getPostID();
        }
    }, [props.posts])

    useEffect(() => {
        if (props.article !== null) {
            getPost(props.article)
        }
    }, [props.article])

    const getContent = async (location) => {
        try {
            let content = await axios.get(location)
            return content.data;
        } catch (error) {
            console.log(error);
        }
    }

    const getPostID = () => {
        const uri = window.location.pathname.split("/")[2];

        if (id === null && props.posts !== null) {
            let postsKeys = Object.keys(props.posts) //!safari error TypeError: null is not an object (evaluating 'Object.keys(e)')
            let exist = false
            /* change for prod */
            postsKeys.filter(key => props.posts[key].post.published).map(key => {
                // postsKeys.map(key => {
                if (props.posts[key].post.publishedLink === uri) {
                    let postID = props.posts[key].year + "-" + props.posts[key].monthDayTime
                    setId(postID)
                    props.onTryFetchArticle(postID);
                    exist = true
                }
            });
            if (!exist) {
                props.navigate('/not-found', { replace: true });
            }
        }
    }

    const getPost = async (post) => {
        if (post !== null && typeof post !== "undefined") {

            const articleDate = new Date(post.year + "-" + post.monthDayTime)

            if (post === null) {
                props.navigate('/not-found', { replace: true });
            } else {

                setTitle(post.caption.title)
                setContent(await getContent(post.post.content))
                setDescription(post.caption.description)
                // setDate(articleDate.getDate() + " " + props.t("partials:months." + articleDate.getMonth().toString()) + " " + articleDate.getFullYear())
                setSharedImg(post.img.src)
                setTimeout(() => {
                    setIsLoading(false)
                }, 500);
            }
        }
    }
    //current base url
    const currentBaseLink = navigator.userAgent !== 'ReactSnap' ? window.location.origin : 'http://www.humanprofiler.com';
    const currentBlogLink = currentBaseLink + props.t("routes:blog.path") + "/"

    return (
        <Auxiliary>
            <Head {...props} id="post" title={title} description={description} img={sharedImg} />
            <ArticleGroup
                {...props}
                individualPost={true}
            >
                {!isLoading ? <>
                    <p className="date font-weight-600">{date}</p>
                    <h1 className="font-weight-800" >{title}</h1>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </> : <div className='h-100 d-flex align-items-center justify-content-center'><Spinner /></div>}
            </ArticleGroup>
        </Auxiliary >
    )
}

const mapStateProps = state => {
    return ({
        recentPosts: state.recentPosts.recentPosts,
        posts: state.posts.posts,
        error: state.posts.error,
        article: state.article.article,
    });
}

const mapDispatchToProps = dispatch => {
    return {
        onTryFetchArticle: (id) => dispatch(fetchArticle(id)),
    }
};

export default connect(mapStateProps, mapDispatchToProps)(withRouter(withTranslation()(Post)))

